import StorageService from '../../storage-service';

const sharedReducer = (state = {}, action) => {
  switch (action.type) {
  case 'SET_META_DATA':
    if (action.error) return state;
    StorageService.set('missing_keys', JSON.stringify(action.data.data.meta_data.missing_keys));
    return {
      ...state,
      missingKeys: action.data.data.meta_data.missing_keys,
      needsVerification: action.data.data.meta_data.need_verification,
    };

  case 'RESET_META_DATA':
    if (action.error) return state;
    return {
      ...state,
      missingKeys: [],
      needsVerification: [],
    };

  case 'CHECK_COMPLETE_PROFILE':
    if (action.error) return state;
    return {
      ...state,
      missingKeys: JSON.parse(action.data),
    };

  default:
    return state;
  }
};

export default sharedReducer;
